import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { LodestoneMove } from './LodestoneMove';
import { LodestoneRules } from './LodestoneRules';
import { LodestoneState } from './LodestoneState';
export class LodestoneMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        return this.flatMapEmptyCoords(state, (coord) => {
            const moves = [];
            for (const direction of this.nextDirection(state)) {
                const orientations = ['diagonal', 'orthogonal'];
                for (const orientation of orientations) {
                    const infos = LodestoneRules.get().applyMoveWithoutPlacingCaptures(state, coord, { direction, orientation });
                    const captures = infos.captures;
                    const numberOfCaptures = captures.length;
                    for (const captureCombination of this.captureCombinations(state, numberOfCaptures)) {
                        moves.push(new LodestoneMove(coord, direction, orientation, captureCombination));
                    }
                }
            }
            return moves;
        });
    }
    captureCombinations(state, numberOfCaptures) {
        if (numberOfCaptures === 0) {
            return new Set([{ top: 0, bottom: 0, left: 0, right: 0 }]);
        }
        else {
            let combinations = new Set();
            const available = state.remainingSpacesDetails();
            const subCombinations = this.captureCombinations(state, numberOfCaptures - 1);
            for (const subCombination of subCombinations) {
                if (subCombination.top + 1 <= available.top) {
                    combinations = combinations.addElement({ ...subCombination, top: subCombination.top + 1 });
                }
                if (subCombination.bottom + 1 <= available.bottom) {
                    combinations = combinations.addElement({ ...subCombination, bottom: subCombination.bottom + 1 });
                }
                if (subCombination.left + 1 <= available.left) {
                    combinations = combinations.addElement({ ...subCombination, left: subCombination.left + 1 });
                }
                if (subCombination.right + 1 <= available.right) {
                    combinations = combinations.addElement({ ...subCombination, right: subCombination.right + 1 });
                }
            }
            if (combinations.size() === 0) {
                // It was not possible to place all captures, so we keep the sub combinations
                return subCombinations;
            }
            return combinations;
        }
    }
    flatMapEmptyCoords(state, f) {
        let moves = [];
        for (let y = 0; y < LodestoneState.SIZE; y++) {
            for (let x = 0; x < LodestoneState.SIZE; x++) {
                const coord = new Coord(x, y);
                const piece = state.getPieceAt(coord);
                if (piece.isEmpty() && piece.isUnreachable() === false) {
                    moves = moves.concat(f(coord));
                }
                else if (piece.isLodestone() && piece.owner === state.getCurrentPlayer()) {
                    // A player can also put a lodestone on its previous location
                    moves = moves.concat(f(coord));
                }
            }
        }
        return moves;
    }
    nextDirection(state) {
        const nextDirection = state.nextLodestoneDirection();
        if (nextDirection.isPresent()) {
            return [nextDirection.get()];
        }
        else {
            return ['push', 'pull'];
        }
    }
}
